<mat-card color="primary" id="racc" class="desktop-container" *ngIf="screenMode==='desktop'">
  <div fxLayout="row wrap"  fxLayoutAlign="space-between center">
    
    <div fxFlex="calc(15%)" class="racc-icon"> 
      <img src="assets/img/logo_racc.svg" i18n-alt alt="Logo RACC" width="48px">
    </div>

    <div fxFlex="calc(40%)" fxFlexAlign="center" class="input-container">
      <input (click)="setSearchAutocomplete();" type="search" #search class="search" [(ngModel)]="searchText" placeholder="">
      <div class="search-box-placeholder-wrapper" *ngIf="searchText===''">
        <mat-icon class="search-icon">search</mat-icon>
      </div>
    </div>
     
    <div fxFlex="calc(45%)" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px"> <!-- BOTONS SUBMENU -->
      <div ng-container *ngFor="let submenu of submenus" fxFlex="calc(33% - 10px)"
      (click)="onSelect(submenu)">
        <div class="submenu-icon" [class.selected]="selectedSubmenu === submenu" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
          <img  src="assets/img/{{submenu}}{{submenu === selectedSubmenu? 'Selected' : ''}}.svg"   alt="{{submenu}}">
          <div i18n>
            {submenu, select, rutes {Rutas} alertes {Alertas} serveis {Servicios} }
          </div>
        </div>
      
      </div>

    </div>
  </div>

  <div [hidden]="selectedSubmenu==='' || selectedSubmenu === 'cerca'" class="submenu">
    <div [hidden]="selectedSubmenu !== 'serveis'">
      <app-serveis></app-serveis>
    </div>
    <div [hidden]="selectedSubmenu !== 'alertes'">
      <app-alertes></app-alertes>
    </div>
    <div [hidden]="selectedSubmenu !== 'rutes'">
      <app-rutes (selectedOption)='onEventDirectionsOption($event)' (directionsEmitter)="onEventDirections($event)" (toggleEmitter)="onEventToggleDirections($event)" (preuKmEmitter)="setPreuKm($event)"></app-rutes>
      
    </div>
  </div>

  <app-llista-incidencies [hidden]="selectedSubmenu!=='alertes'" [setLlistaIncidencies]="llistaIncidencies" [infowindow]="infowindow" [map]="map"></app-llista-incidencies>
  <app-llista-rutes [hidden]="selectedSubmenu!=='rutes' || !rutaCalculada" (deleteEmitter)="onEventToggleDirections($event)"></app-llista-rutes>
  

</mat-card>












<div class="responsive-container" fxLayout="column" fxLayoutAligne="start start" *ngIf="screenMode==='portrait'">

  <div class="responsive-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <div fxFlex="calc(10%-15px)"> 
      <img src="assets/img/logo_racc.svg" alt="Logo RACC" height="45px">
    </div>
  
    <div class="responsive-input-container" fxFlex="calc(30%-15px)">
      <input (click)="setSearchAutocomplete();" type="search" #search class="search" [(ngModel)]="searchText" placeholder="">
      <div class="responsive-search-box-placeholder-wrapper" *ngIf="searchText===''">
        <mat-icon class="responsive-search-icon">search</mat-icon>
      </div>
    </div>
  
    <div fxFlex="calc(50%-15px)" fxLayout="row" fxLayoutAlign="center center">
      <div ng-container *ngFor="let submenu of submenus"
      (click)="onSelect(submenu)" fxFlex="33%">
        <div class="responsive-submenu-icon" [class.selected]="selectedSubmenu === submenu" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2px">
          <img  src="assets/img/{{submenu}}{{submenu === selectedSubmenu? 'Selected' : ''}}.svg"   alt="{{submenu}}">
          <div i18n>
            {submenu, select, rutes {Rutas} alertes {Alertas} serveis {Servicios} }
          </div>
        </div>
      
      </div>
    </div>
  </div>

  <div [hidden]="selectedSubmenu==='' || selectedSubmenu === 'cerca'" class="submenu" id="objectiu">
    <div [hidden]="selectedSubmenu !== 'serveis'">
      <app-serveis></app-serveis>
    </div>
    <div [hidden]="selectedSubmenu !== 'alertes'">
      <app-alertes></app-alertes>
    </div>
    <div [hidden]="selectedSubmenu !== 'rutes'">
      <app-rutes (selectedOption)='onEventDirectionsOption($event)' (directionsEmitter)="onEventDirections($event)" (toggleEmitter)="onEventToggleDirections($event) " (preuKmEmitter)="setPreuKm($event)"></app-rutes>
      
    </div>
  </div>
  

  <app-llista-incidencies (clickEmitter)="selectedSubmenu = ''" [hidden]="selectedSubmenu!=='alertes'" [setLlistaIncidencies]="llistaIncidencies" [infowindow]="infowindow" [map]="map"></app-llista-incidencies>
  <app-llista-rutes [hidden]="selectedSubmenu!=='rutes' || !rutaCalculada" (deleteEmitter)="onEventToggleDirections($event)"></app-llista-rutes>

</div>







<div class="responsive-landscape-container" fxLayout="row"  fxLayoutAlign="start start" *ngIf="screenMode==='landscape'">

  <div class="responsive-landscape-menu" fxLayout="column" fxLayoutAlign="space-between center"  fxFlex="10%">

    <div fxFlex="20%"> 
      <img src="assets/img/logo_racc.svg" alt="Logo RACC" height="45px">
    </div>

    <div (click)="onSelect('cerca')" fxFlex="20%">
      <div class="responsive-submenu-icon" [class.selected]="selectedSubmenu === 'cerca'" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2px">
        <mat-icon class="responsive-search-icon" [class.selected]="selectedSubmenu === 'cerca'">search</mat-icon>
        <div i18n>
          Buscar
        </div>
      </div>
    </div>
    
    <div ng-container *ngFor="let submenu of submenus"
    (click)="onSelect(submenu)" fxFlex="20%">
      <div class="responsive-submenu-icon" [class.selected]="selectedSubmenu === submenu" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2px">
        <img  src="assets/img/{{submenu}}{{submenu === selectedSubmenu? 'Selected' : ''}}.svg"   alt="{{submenu}}">
        <div i18n>
          {submenu, select, rutes {Rutas} alertes {Alertas} serveis {Servicios} }
        </div>
      </div>
    
    </div>
  </div>

  <div [class.responsive-landscape-submenu]="selectedSubmenu !== '' " 
  [class.scroll]="selectedSubmenu === 'alertes'" [class.buttons-list]="selectedSubmenu === 'serveis' || selectedSubmenu === 'alertes'">
    <div [hidden]="selectedSubmenu===''" class="submenu">

      <div [hidden]="selectedSubmenu !== 'cerca'">
        <div class="responsive-input-container" fxFlex="calc(30%-15px)">
          <input (click)="setSearchAutocomplete();" type="search" #search #searchFocus class="search" [(ngModel)]="searchText" placeholder="">
          <div class="responsive-search-box-placeholder-wrapper" *ngIf="searchText===''">
            <mat-icon class="responsive-search-icon">search</mat-icon>
          </div>
        </div>
      </div>

      <div [hidden]="selectedSubmenu !== 'serveis'" >
        <app-serveis></app-serveis>
      </div>

      <div [hidden]="selectedSubmenu !== 'alertes'">
        <app-alertes></app-alertes>
      </div>
      
      <div [hidden]="selectedSubmenu !== 'rutes'">
        <app-rutes  [hidden]="showRouteDetails && rutaCalculada"  (selectedOption)='onEventDirectionsOption($event)' (directionsEmitter)="onEventDirections($event)" (toggleEmitter)="onEventToggleDirections($event) " (preuKmEmitter)="setPreuKm($event)"></app-rutes>
        <div [hidden]="!showRouteDetails || !rutaCalculada">
          <div class="go-back" (click)="showRouteDetails = false" fxLayout="row" fxLayoutGap="5px"><img src="assets/img/backArrow.svg" alt="Tornar als resultats"><span>Tornar a calcular ruta</span></div>
          <app-llista-rutes [hidden]="selectedSubmenu!=='rutes' || !rutaCalculada" (deleteEmitter)="onEventToggleDirections($event)"></app-llista-rutes>
        </div>
      </div>
    </div>
    
  
    
  </div>

  <app-llista-incidencies class="responsive-landscape-submenu llista" [hidden]="selectedSubmenu!=='alertes'"
  [setLlistaIncidencies]="llistaIncidencies" [infowindow]="infowindow" [map]="map" (clickEmitter)="selectedSubmenu = ''"></app-llista-incidencies>
  
  


</div>